import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerPaymentMethodStatusComponent } from './customer-payment-method-status.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [CustomerPaymentMethodStatusComponent],
  exports: [CustomerPaymentMethodStatusComponent],
  imports: [CommonModule, MatIconModule, RouterModule, RouterModule],
})
export class CustomerPaymentMethodStatusModule {}
